import { Component, OnInit, Input, ViewChild, Output, EventEmitter } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { HeaderItemModel } from '../../shared/model/header-item.model';
import { HeaderItemModalComponent } from './header-item-modal/header-item-modal.component';
import { HeaderItemTypeTranslation } from '../../shared/enum/header-item-type';
import { ConfirmComponent } from '../../shared/component/confirm/confirm.component';
import _ from 'lodash'
@Component({
	selector: 'app-header-item',
	templateUrl: './header-item.component.html',
	styleUrls: ['./header-item.component.css']
})
export class HeaderItemComponent implements OnInit {
	@ViewChild(HeaderItemModalComponent) headerItemModal: HeaderItemModalComponent;
	@ViewChild(ConfirmComponent) confirm: ConfirmComponent;
	@Input() isEndpointEnabled: number | boolean;
	@Input() headerItems: HeaderItemModel[];
	@Output() save = new EventEmitter<HeaderItemModel[]>();

	headerItemTypes = HeaderItemTypeTranslation;
	rowIndex: number = null;
	previousHeaderItem: HeaderItemModel
	constructor(
		private translateService: TranslateService,
	) { }

	ngOnInit() { }

	saveHeaderItem(e) {
		// console.log(this.headerItems)
		if (e.itemOrder > this.headerItems.length && !this.previousHeaderItem) {
			this.headerItems.push(e)
		} else if (this.previousHeaderItem) {
			if (this.previousHeaderItem.itemOrder !== e.itemOrder) {
				this.headerItems = this.headerItems.reduce((acc: HeaderItemModel[], crr: HeaderItemModel, i: number) => {
					if (i != this.rowIndex) {
						if (e.itemOrder < this.previousHeaderItem.itemOrder) {
							if(crr.itemOrder >= e.itemOrder && crr.itemOrder < this.previousHeaderItem.itemOrder) {
								acc.push({...crr, itemOrder: crr.itemOrder+1})
							}
							else 
								acc.push(crr)
						}
						else {
							if(crr.itemOrder <= e.itemOrder && crr.itemOrder > this.previousHeaderItem.itemOrder) {
								acc.push({...crr, itemOrder: crr.itemOrder-1})
							}
									
							else 
								acc.push(crr)
						}
					} else {
						// console.log(e)
						acc.push(e)
					}
					return acc
				}, [])
				
			}

		} else {
			this.headerItems = this.headerItems.reduce((acc: HeaderItemModel[], crr: HeaderItemModel, i: number) => {
				if(crr.itemOrder >= e.itemOrder)
					acc.push({...crr, itemOrder: crr.itemOrder + 1})
				else acc.push(crr)
				return acc
			}, [])
			this.headerItems.push(e)
		}
		this.headerItems = _.orderBy(this.headerItems, 'itemOrder')
		this.rowIndex = null
		this.previousHeaderItem = null
		// console.log(this.headerItems)
		this.save.emit(this.headerItems);
	}

	deleteHeaderItem(row: HeaderItemModel, ) {
		this.rowIndex = this.headerItems.indexOf(row);
		// this.confirm.key = "header-item";
		// console.log('Teste')
		// comp.confirm()
		this.confirm.confirm();
	}

	acceptDeleteHeaderItem(key) {
		let deletedHeaderItem = this.headerItems.splice(this.rowIndex, 1);
		this.headerItems = this.headerItems.map(({itemOrder, ...otherProps}) => {
			return {
				itemOrder: itemOrder > deletedHeaderItem[0].itemOrder ? (itemOrder-1 ): itemOrder,
				...otherProps
			}
		})
		this.save.emit(this.headerItems)
	}

	rejectDeleteHeaderItem() {
		this.rowIndex = null;
	}

	selectField = (item: HeaderItemModel, value: boolean, field: string = 'primary') => field ?
		this.headerItems.find(({itemOrder}) => itemOrder === item.itemOrder)[field] = value : '';

	openModal(headerItem?) {	
		this.headerItemModal.headerItem = headerItem as HeaderItemModel || new HeaderItemModel();
		this.headerItemModal.headerItems = this.headerItems;
		
		if (headerItem) {
			this.rowIndex = this.headerItems.indexOf(headerItem);
			this.headerItemModal.orderLimit = this.headerItems.length
			this.previousHeaderItem = { ...headerItem }
			// this.rowIndex = this.headerItems.length;
		} else {
			// this.rowIndex = this.headerItems.length;
			// this.headerItemModal.isNew = true

			this.headerItemModal.headerItem.itemOrder = this.headerItems.length + 1
			this.headerItemModal.orderLimit = this.headerItems.length + 1
		}


		this.headerItemModal.display = true;
	};

	translate = (key: string) => this.translateService.instant(key || "invalid");
	tUpper = (key) => this.translate(key).toString().toUpperCase();
	tCap = (key) =>
	this.translate(key).charAt(0).toUpperCase() + this.translate(key).slice(1);


	/*
	
	constructor(private checklistService: ChecklistService, private headerItemService: HeaderItemService, private listService: ListService) { }

	deleteItem(item: HeaderItemModel) {
		this.headerItemService.delete(item.id).subscribe(result => {
			this.display = false;
		});
	}



	save() {
		this.headerItemService.save(this.headerItem).subscribe(result => {
			this.loadHeaderItems(this.checklistId);
			this.onSaved.emit();
			this.headerItem = new HeaderItemModel();
			this.display = false;
		},
		({error}) => {
			this.gMessage.error(error.message);
		});
	}
	*/
}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/checklist-form/header-item/header-item.component.ts